import Head from "next/head";
import {useRouter} from "next/router";
import {site_data} from "../data/site_data";

const SITE_URL = "https://www.engineeringbookclub.com";

const Meta = ({title, desc, keyword, image, pageType, author}) => {
  const router = useRouter();
  const canonicalUrl = `${SITE_URL}${router.asPath.split('?')[0]}`;
  const ogImage = image.startsWith('http') ? image : `${SITE_URL}${image}`;

  const structuredData = () => {
    if (pageType === 'book') {
      return {
        "@context": "https://schema.org",
        "@type": "Book",
        "name": title,
        "description": desc,
        "image": ogImage,
        ...(author && {"author": {"@type": "Person", "name": author}}),
        "url": canonicalUrl,
      };
    }
    if (pageType === 'article') {
      return {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": title,
        "description": desc,
        "image": ogImage,
        ...(author && {"author": {"@type": "Person", "name": author}}),
        "publisher": {
          "@type": "Organization",
          "name": site_data.title,
          "logo": {"@type": "ImageObject", "url": `${SITE_URL}/favicon.png`}
        },
        "url": canonicalUrl,
      };
    }
    return null;
  };

  return (
    <div>
      <Head>
        <title>{title}</title>
        <link rel="icon" href="/favicon.png"/>
        <link rel="canonical" href={canonicalUrl}/>
        <meta name="description" content={desc}/>
        <meta name="keywords" content={keyword}/>

        <meta property="og:site_name" content={site_data.title}/>
        <meta property="og:title" content={title}/>
        <meta property="og:description" content={desc}/>
        <meta property="og:image" content={ogImage}/>
        <meta property="og:url" content={canonicalUrl}/>
        <meta property="og:type" content={pageType === 'article' ? 'article' : 'website'}/>

        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:site" content={site_data.twitter}/>
        <meta name="twitter:creator" content={site_data.twitter}/>
        <meta name="twitter:title" content={title}/>
        <meta name="twitter:description" content={desc}/>
        <meta name="twitter:image" content={ogImage}/>

        {structuredData() && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(structuredData())}}
          />
        )}
      </Head>
    </div>
  );
};

Meta.defaultProps = {
  title: site_data.title,
  desc: site_data.description,
  keyword: site_data.keyword,
  image: "/images/homepage/engineering-books.png",
};

export default Meta;
